





define(function() {
    'use strict';
    var names = {
        display: 'services/display',
        vector: 'services/display/vector',
        trafficFlow: 'services/trafficFlow',
        traffic: 'services/traffic',
        search: 'services/search',
        routing: 'services/routing'
    };
    /**
     * Immutable object with the names of the different API keys.
     */
    return Object.freeze(names);
});



// WEBPACK FOOTER //
// ./security/apiKeyNames.js